import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RecoveryContext } from "../../App";
import { Link } from "react-router-dom";
import { navigateToOtp } from "../../Utils/navigateToOtp";
import { LoadingPage } from "../LoadingPage";

import logo from "../Assets/Logo.svg";
import gamereview from "../Assets/Game-review.svg";
import ai from "../Assets/AI.svg";
import puzzles from "../Assets/Puzzles.svg";
import book from "../Assets/Book.svg";
import visualisation from "../Assets/Visualisation.svg";

export const EmailPassword = () => {
  const { email, setEmail, fromSignup, setFromSignup } =
    useContext(RecoveryContext);

  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOtpRequest = async (e) => {
    e.preventDefault();
    setFromSignup(false);
    setLoading(true);
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    if (loading) {
      (async () => {
        try {
          await navigateToOtp(email, navigate, setErrorMessage, fromSignup);
        } catch (err) {
          console.error(err);
          setErrorMessage("An error occurred while sending OTP.");
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [loading, fromSignup, email, navigate, setErrorMessage]);

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="container login-mobile-layout">
      <header className="header">
        <img className="logo-image" src={logo} alt="logo" />
        <div className="logo-text">
          <span className="C-logo">C</span>
          <span className="hezzle-logo">
            he<span className="Z-1">Z</span>
            <span className="Z-2">Z</span>le
          </span>
        </div>
        <Link to="/login" className="login-button">
          Log in
        </Link>
      </header>
      <div className="gradient-line"></div>

      <div className="left-half">
        <img className="left-image" src={logo} alt="logo" />
        <div className="features">
          <ul>
            <li>
              <img src={gamereview} className="gamereview-svg" alt="" />
              Enhance your game analysis!
            </li>
            <br />
            <li>
              <img src={ai} className="ai-svg" alt="" />
              Get AI-assisted move breakdown.
            </li>
            <br />
            <li>
              <img src={puzzles} className="puzzles-svg" alt="" />
              Exclusive puzzles from your games!
            </li>
            <br />
            <li>
              <img src={book} className="book-svg" alt="" />
              Master your openings and middle game.
            </li>
            <br />
            <li>
              <img src={visualisation} className="visualisation-svg" alt="" />
              Level up your visualization skills!
            </li>
            <br />
          </ul>
        </div>
      </div>

      <div className="signup-form">
        <div className="line"></div>
        <h2 className="welcome">Reset your password</h2>
        <form className="EmailPasswordform" onSubmit={handleOtpRequest}>
          <input
            type="text"
            placeholder="Email"
            className="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button type="submit" className="create-account-button">
            Send OTP
          </button>
        </form>
        <div>
          {errorMessage && <p className="error-message">{errorMessage}</p>}
        </div>
      </div>
    </div>
  );
};
